import api from '@/api';

class ClientActionCategory {
    maxDepth = 4;

    /**
     * Origin risk assessment
     *
     * @returns {number}
     * @constructor
     */
    static ORIGIN_RISK_ASSESSMENT_ID() {
        return 1;
    }

    /**
     *
     * @returns {*}
     * @constructor
     */
    static MAX_DEPTH() {
        return 4;
    }

    /**
     * Origin property
     *
     * @returns {number}
     * @constructor
     */
    static ORIGIN_PROPERTY_ID() {
        return 2;
    }

    static list(originId, complianceTypeId, parentCategoryId = 0) {
        return api.get('/actions/client/categories', { params: { originId, complianceTypeId, parentCategoryId } });
    }
}

export default ClientActionCategory;
